/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback } from 'react'

import SectionTitle from '../../components/SectionTitle'
import { getTranslate } from '../../localization'
import { Facility, FacilityGroup } from '../../types/accommodationFacilities'
import FacilityItemCheckBox from './FacilityItemCheckBox'
import useStyles from './styles/FacilitiesCategory.styles'

interface FacilitiesCategoryProps {
  title: string
  facilities: Facility[]
  selectedIDs: string[]
  setSelectedIDs: React.Dispatch<React.SetStateAction<string[]>>
}

const FacilitiesCategory: React.FC<FacilitiesCategoryProps> = ({
  title,
  facilities,
  selectedIDs,
  setSelectedIDs
}) => {
  const classes = useStyles()

  return (
    <div
      className={classes.root}
      style={{ gridRowEnd: `span ${facilities.length + 2}` }}>
      <SectionTitle title={getTranslate(title)} marginBottom />
      <div className={classes.itemsContainer}>
        {facilities.map((item: Facility, index) => (
          <FacilityItemCheckBox
            key={item.label}
            data={item}
            index={index}
            selectedIDs={selectedIDs}
            setSelectedIDs={setSelectedIDs}
          />
        ))}
      </div>
    </div>
  )
}

export default FacilitiesCategory
